var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubadminmanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.415 18.75C10.415 14.502 13.5986 11.001 17.7051 10.4883V10.415C17.9736 10.0244 18.7451 9.375 18.7451 8.33008C18.7451 7.28516 17.7051 6.24512 17.7051 5.72754C17.71 1.5625 15.5859 0 12.5 0C9.5459 0 7.29004 1.5625 7.29004 5.72754C7.29004 6.25 6.25 7.29004 6.25 8.33008C6.25 9.37012 6.99219 10.0586 7.29004 10.415C7.29004 10.415 7.29004 11.4551 7.8125 13.0176C7.8125 13.54 8.85254 14.0576 9.375 14.5801C9.375 15.1025 9.375 15.6201 8.85254 16.665L3.125 17.71C1.04004 18.2275 0 21.875 0 25H13.252C11.5186 23.4717 10.415 21.2402 10.415 18.75ZM18.75 12.5C15.2979 12.5 12.5 15.2979 12.5 18.75C12.5 22.2021 15.2979 25 18.75 25C22.2021 25 25 22.2021 25 18.75C25 15.2979 22.2021 12.5 18.75 12.5ZM22.915 19.79H19.79V22.915H17.7051V19.79H14.5801V17.7051H17.7051V14.5801H19.79V17.7051H22.915V19.79Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubadminmanagement);
export default __webpack_public_path__ + "static/media/subadminmanagement.1fe875fac0a9867fc301d87a342f17cf.svg";
export { ForwardRef as ReactComponent };